import { render, staticRenderFns } from "./menu5_video_clip_q.vue?vue&type=template&id=c925b0e8&scoped=true"
import script from "./menu5_video_clip_q.vue?vue&type=script&lang=js"
export * from "./menu5_video_clip_q.vue?vue&type=script&lang=js"
import style0 from "./menu5_video_clip_q.vue?vue&type=style&index=0&id=c925b0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c925b0e8",
  null
  
)

export default component.exports